import { ActivityType } from '../enums/activityType';
import { CompensationPayoutEntity } from '../enums/compensationPayoutEntity';
import { ServiceCode } from '../enums/serviceCode';
import { ServiceType } from '../enums/serviceType';
import { never } from './never';

export function getAllowedCompensationsByServiceAndEntity(
    serviceType: ServiceType,
    serviceCode: ServiceCode,
    entity: CompensationPayoutEntity
) {
    let allowedActivityTypes: ActivityType[] = [];

    switch (entity) {
        case CompensationPayoutEntity.serviceConsumer:
            allowedActivityTypes = [ActivityType.request];
            break;
        case CompensationPayoutEntity.serviceProvider:
            if (serviceType === ServiceType.consultation) {
                allowedActivityTypes = [ActivityType.consultation];
            } else {
                allowedActivityTypes = [ActivityType.grading, ActivityType.biometrics];

                if (serviceCode === ServiceCode.TOO) {
                    allowedActivityTypes.push(ActivityType.glaucoma);
                }
            }
            break;
        case CompensationPayoutEntity.serviceSupervisor:
            allowedActivityTypes = [ActivityType.qualityControl];
            break;
        case CompensationPayoutEntity.serviceOrganizationSetting:
        case CompensationPayoutEntity.serviceGroupSetting:
            allowedActivityTypes = [ActivityType.request];

            if (serviceType === ServiceType.consultation) {
                allowedActivityTypes.push(ActivityType.consultation);
            } else {
                allowedActivityTypes = [...allowedActivityTypes, ActivityType.grading, ActivityType.biometrics];

                if (serviceCode === ServiceCode.TOO) {
                    allowedActivityTypes.push(ActivityType.glaucoma);
                }
            }
            break;
        default:
            never(entity);
    }

    return allowedActivityTypes;
}
